import { render, staticRenderFns } from "./news_detail.vue?vue&type=template&id=7a050ee1&scoped=true&"
import script from "./news_detail.vue?vue&type=script&lang=js&"
export * from "./news_detail.vue?vue&type=script&lang=js&"
import style0 from "./news_detail.vue?vue&type=style&index=0&id=7a050ee1&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a050ee1",
  null
  
)

export default component.exports